
$( document ).ready(function() {

  $('.custom-collection-slider').slick({
    slidesToShow: 3,     
    slidesToScroll: 1, 
    autoplay: false,      
    dots: false,      
    arrows: true,        
    infinite: true,      
    speed: 500,           
    draggable: true,      
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2, // Adjust for medium screens
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1, // Adjust for smaller screens
        }
      }
    ]
  });
  
  

 // Event delegation for quantity buttons
  // document.body.addEventListener('click', function(e) {
  //   if (e.target.classList.contains('qty-btn')) {
  //     const isPlus = e.target.classList.contains('plus');
  //     const card = e.target.closest('.custom-product-card');
  //     const qtyInput = card.querySelector('.quantity-input');
  //     let currentQty = parseInt(qtyInput.value);

  //     if (isPlus) {
  //       qtyInput.value = currentQty + 1;
  //     } else {
  //       if (currentQty > 1) {
  //         qtyInput.value = currentQty - 1;
  //       }
  //     }
  //   }
  // });

});  

